var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTutorialLeftArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 10,
    viewBox: "0 0 55 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16368 0.125236C5.80961 0.79605 2.93469 2.521 0.347113 4.62927C-0.22787 5.10858 -0.0360525 6.06689 0.538931 6.45021C3.60551 8.17516 6.95958 9.61261 10.5051 9.99594C11.5593 10.0918 11.6553 8.46265 10.697 8.27099C8.10954 7.60017 5.61779 6.64187 3.22218 5.39607C3.893 4.91692 4.65964 4.43761 5.42629 4.05429C4.75547 4.7251 5.04296 6.25855 6.28876 6.25855C21.9091 6.35438 38.0085 9.9001 53.4374 7.12102C54.6832 6.92936 54.3957 4.82109 53.1499 4.91692C37.4337 6.16271 22.0051 3.76679 6.28876 3.67096C6.19293 3.67096 6.0971 3.67096 6.0971 3.67096C7.24707 3.09598 8.39703 2.71282 9.73866 2.42517C11.2719 2.23335 10.697 -0.162256 9.16368 0.125236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorialLeftArrowWhite);
export default __webpack_public_path__ + "static/media/ic_tutorial_left_arrow_white.ffcbf7cc432727f6bf353ae6fa3962d3.svg";
export { ForwardRef as ReactComponent };